import clsx from 'clsx';

type DropzoneProps = {
  canDrop: boolean;
  isOver: boolean;
};

export const Dropzone = ({ canDrop, isOver }: DropzoneProps) => {
  return (
    <div data-testid="dropzone" className="relative p-4 flex items-center flex-col">
      <div
        className={clsx('mt-4 mb-2 border-2 w-1/2 h-24 flex justify-center items-center rounded-xl', {
          'border-darkgray border-dashed': !canDrop && !isOver,
          'border-edit border-dashed': canDrop && !isOver,
          'border-edit border-solid': canDrop && isOver,
        })}
      >
        <i className="c-icon-custom c-icon-custom--modules-2 text-2xl text-darkgray" />
      </div>
      <div className="text-center text-darkgray">
        {canDrop && isOver ? 'Release to drop' : 'Drag modules from the module library here'}
      </div>
    </div>
  );
};
